import { Col, Row } from 'antd';
import styled from 'styled-components';
import {
  maxTablet, primaryFont, scrollbar, wMedium,
} from 'Utils/utilsStyle';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch } from 'react-redux';
import { Company } from '../../../Types/CompaniesTypes';
import CompanyWidgetSmall from '../../common/components/CompanyWidgetSmall';
import CompanyWidgetSmallSkeleton from '../../common/skeleton/CompanyWidgetSmallSkeleton';
import AlertsCompanyArea from './AlertsCompanyArea';
import AlertsCompanyHead from './AlertsCompanyHead';
import AlertsSearch from './AlertsSearch';
import { NoFilterText } from './AlertsTriggersPanel';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';

const Wrapper = styled.div`
  .infinite-scroll-component__outerdiv{
    width: 100%;
  }
  .infiniteScrollStyle{
    padding: 8px 4px 0 0;
    border-radius: 0 !important;
    ${scrollbar};
    max-height: 414px !important;

    @media screen and (max-width: ${maxTablet}) {
      margin-right: 6px;
    }
  }
  .skeletonWrapper{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 5px;
  }
`;

const NoCompanies = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family:${primaryFont};
  font-size:13px;
  font-weight:${wMedium};
`;

type Props = {
  load: boolean
  companies: Company[]
  selection: (a: boolean, b: string) => void
  onSearching: (a: string) => void
  isSearch: boolean
  isSelected: boolean
};

const AlertsCompanyPanel = function AlertsCompanyPanel(props: Props) {
  const {
    load,
    companies,
    selection,
    onSearching,
    isSearch,
    isSelected,
  } = props;
  const dispatch = useDispatch();

  const fetchMore = () => {
    dispatch(companiesActions.getCompanies({ offset: companies?.length }));
  };

  return (
    <Wrapper>
      <AlertsCompanyHead />
      {!load && !isSearch
        && !isSelected
        && <NoFilterText>Please Select One Company at Least</NoFilterText>}
      <AlertsCompanyArea>
        <InfiniteScroll
          hasMore
          dataLength={companies.length}
          next={() => fetchMore()}
          className="o-x-hidden infiniteScrollStyle"
          loader={false}
        >
          <Row gutter={8} className="w-100 margin-alert-to-center">
            {companies.map((company: Company) => (
              <Col span={8}>
                <CompanyWidgetSmall
                  logo={company.companyLogo}
                  persona={company.companyPersonality}
                  triggerColor={company.companyPulse}
                  checked={company.isSelected}
                  selection={(a, b) => selection(a, b)}
                  companyId={company.companyId.toString()}
                  backgroundPosition="center 5px"
                  backgroundSize="50%"
                />
              </Col>
            ))}
            <div className="skeletonWrapper">
              {load && [1, 2, 3, 4, 5, 6, 7, 8].map(() => <CompanyWidgetSmallSkeleton />)}
            </div>
            {
              !load && !companies.length
              && <NoCompanies>No Companies Found</NoCompanies>
            }
          </Row>
        </InfiniteScroll>
      </AlertsCompanyArea>

      <AlertsSearch placeholderText="Find additional companies…" onSearching={onSearching} loading={load} margin="20px 0px" />
    </Wrapper>
  );
};
export default AlertsCompanyPanel;
